<template>
  <div
    v-if="message"
    :class="[
      'flex items-start gap-2.5 px-4 py-3 rounded-xl text-sm font-medium',
      isSuccess
        ? 'bg-emerald-50 text-emerald-700 border border-emerald-200'
        : 'bg-red-50 text-red-700 border border-red-200'
    ]"
  >
    <svg v-if="isSuccess" class="w-4 h-4 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"/>
    </svg>
    <svg v-else class="w-4 h-4 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
    </svg>
    {{ message }}
  </div>
</template>

<script>
export default {
  name: 'AlertBanner',
  props: {
    message: { type: String, default: '' },
    type: { type: String, default: 'error' }
  },
  computed: {
    isSuccess() { return this.type === 'success' }
  }
}
</script>
